"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    /**
     * A change in the clock account.
     */
    EventType[EventType["CLOCK"] = 0] = "CLOCK";
})(EventType = exports.EventType || (exports.EventType = {}));
